import { Component, OnInit } from '@angular/core';
import { ReadConfigService } from '../services/common/read-config.service';

@Component({
  selector: 'app-service-error',
  templateUrl: './service-error.component.html',
  styleUrls: ['./service-error.component.css']
})
export class ServiceErrorComponent implements OnInit {
  message: any;

  constructor(private readConfigService: ReadConfigService) { }

  ngOnInit() {
    const config = this.readConfigService.getServiceErrorText();
    this.message = config.Message;
  }
}
